import { configureStore } from '@reduxjs/toolkit'

// **Reducer Imports
import authReducer from './slice/auth'
import workspaceReducer from './slice/workspace'
import challengeReducer from './slice/challenge'
import contestReducer from './slice/contest'
import editorReducer from './slice/editor'
import candidateReducer from './slice/candidate'
import usersReducer from './slice/users'
import databaseReducer from './slice/database'
import developerReducer from './slice/developer'
import coursesReducer from './slice/courses'
import learnerReducer from './slice/learner'

// **ENV Variable
import { ENVIRONMENT } from '../env/env'

const rootReducer = {
  auth: authReducer,
  workspace: workspaceReducer,
  challenge: challengeReducer,
  contest: contestReducer,
  editor: editorReducer,
  candidate: candidateReducer,
  users: usersReducer,
  database: databaseReducer,
  developer: developerReducer,
  courses: coursesReducer,
  learner: learnerReducer
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false
    })
  },
  devTools: ENVIRONMENT?.toLowerCase() === 'dev'
})

export { store }
